import get from 'lodash/get';

import Steven from 'helpers/steven';

export const recordAddedAndRemovedTags = (
  oldRecordables,
  newRecordables,
  inputTags,
) => {
  try {
    /**
     * In the case of bulk adding tags, the tag data might not be present in the cache.
     * Therefore, we won't be able to determine what has changed. In this scenario,
     * we log each current tagging as if it were newly created, even though some of
     * these tags might already exist on the recordable.
     */
    if (Array.isArray(newRecordables?.recordablesAlterTags?.recordables)) {
      newRecordables.recordablesAlterTags.recordables.forEach((recordable) => {
        recordable.tags.edges.forEach(({ node }) => {
          if (inputTags.includes(node.displayValue)) {
            Steven.entityCrud({
              source: recordable.__typename.toLowerCase(),
              action: 'created',
              entity_id: node.databaseId,
              entity_type: 'tagging',
            });
          }
        });
      });
    } else if (oldRecordables && newRecordables) {
      Object.entries(oldRecordables).forEach(([nodeId, oldRecordable]) => {
        const newRecordable = newRecordables[nodeId];

        if (!newRecordable) return;

        const oldTags = get(oldRecordable, 'node.tags.edges', []).map((tag) =>
          get(tag, 'node.databaseId'),
        );

        const newTags = get(newRecordable, 'tags.edges', []).map((tag) =>
          get(tag, 'node.databaseId'),
        );

        const addedDbIds = newTags.filter((id) => !oldTags.includes(id));
        const removedDbIds = oldTags.filter((id) => !newTags.includes(id));

        const entityType = get(newRecordable, '__typename').toLowerCase();
        const entityId = get(newRecordable, 'databaseId').toLowerCase();

        // only invoke these events if the cache had the databaseId for the recordable
        if (entityType && entityId) {
          addedDbIds.forEach((databaseId) => {
            Steven.entityCrud({
              action: 'created',
              entity_id: databaseId,
              entity_type: 'tagging',
              source: entityType,
            });
          });

          removedDbIds.forEach((databaseId) => {
            Steven.entityCrud({
              action: 'deleted',
              entity_id: databaseId,
              entity_type: 'tagging',
              source: entityType,
            });
          });
        }
      });
    }
  } catch (e) {
    // not a critical error if we can't record tag applied events
  }
};
